import { useNavigate } from "react-router-dom";

export default function ProjectListRow({ project }) {
  const { id, title, status, statusColor, centre, stage, progress } = project;
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/app/projects/${id}`)}
      className="grid grid-cols-[2fr_1.1fr_1.1fr_1.3fr_1fr] items-center gap-4 px-6 py-5 border-b border-gray-100 last:border-0 hover:bg-gray-50/60 cursor-pointer transition"
    >
      <div>
        <p className="font-bold text-gray-900">{title}</p>
        <p className="text-xs text-gray-400 mt-0.5">{id}</p>
      </div>

      <p className="text-sm text-gray-500">{centre}</p>

      <p className="text-sm text-gray-900">{stage}</p>

      <div>
        <div className="w-full max-w-[180px] h-1.5 bg-gray-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-[#0f1229] rounded-full"
            style={{ width: `${progress}%` }}
          />
        </div>
        <p className="text-xs text-gray-500 mt-1.5">{progress}%</p>
      </div>

      <div className="justify-self-end">
        <span className={`text-xs font-semibold px-3 py-1 rounded-full ${statusColor}`}>
          {status}
        </span>
      </div>
    </div>
  );
}